module.exports = __webpack_public_path__ + "static/media/0_2019_02_02.ee3f575a.jpg";